module.exports = __webpack_public_path__ + "static/laughing-logo-40b3fba5895ea52dcb81febe8f058350.png";